import { useSuspenseQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import type { GetGoodsReviewsParams } from 'shared/src/api/goodsService/getGoodsReviews';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import { queryKey } from '../../../../../constant/queryKey';

export const useGoodsReviews = (params?: GetGoodsReviewsParams) => {
  const sno = useGoodsSno();
  return useSuspenseQuery({
    queryKey: queryKey.goodsReviews(sno, params),
    queryFn: () => goodsService.getGoodsReviews(sno, params),
  });
};
